import { render, staticRenderFns } from "./explanation.vue?vue&type=template&id=8ba3e5c0&scoped=true&"
import script from "./explanation.vue?vue&type=script&lang=js&"
export * from "./explanation.vue?vue&type=script&lang=js&"
import style0 from "./explanation.vue?vue&type=style&index=0&id=8ba3e5c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba3e5c0",
  null
  
)

export default component.exports